import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminPageSectionIcon from '../SectionIcon';

import { sections } from '../../../../helpers/PageSections';
import { getSetting } from '../../../../helpers/Settings';

const AdminPageEditSidebarSections = ({ handleAddSection }) => {
  const intl = useIntl();

  return (
    <div className="sections">
      {sections(intl).map(section => (
        <FormGroup key={section.section}>
          <Button
            id={`sb-${section.section}`}
            className="section-button"
            outline
            onClick={() => {
              handleAddSection(section);
            }}
          >
            <AdminPageSectionIcon sectionId={section.section} />
            {
              (getSetting('cs1') && section.section === 'collections-grid') ?
                intl.formatMessage({ defaultMessage: 'Latest Coverage' }) :
                section.name
            }
          </Button>
          {section.description && (
            <UncontrolledTooltip fade={false} target={`sb-${section.section}`}>
              {section.description}
            </UncontrolledTooltip>
          )}
        </FormGroup>
      ))}
    </div>
  );
};

AdminPageEditSidebarSections.propTypes = {
  handleAddSection: PropTypes.func.isRequired,
};

export default AdminPageEditSidebarSections;
